import { computed, ref, Ref, watch } from "vue";
import { GenericField } from "@/business/shared/commons/validator/validatorsTypes";
import { RequiredRule } from "@/business/shared/commons/validator/rules/RequiredRule";
import { EmailRule } from "@/business/shared/commons/validator/rules/EmailRule";
import { validator } from "@/business/shared/commons/validator/validator";

export function loginValidator() {
  const email: Ref<GenericField> = ref({
    enabled: false,
    val: "",
    errors: [],
    isSuccess: true,
    rules: [
      new RequiredRule("El correo del usuario es obligatorio"),
      new EmailRule("El correo electrónico debe tener un formato válido"),
    ],
  });

  const password: Ref<GenericField> = ref({
    enabled: false,
    val: "",
    errors: [],
    isSuccess: true,
    rules: [
      new RequiredRule("La contraseña es obligatoria"),
    ],
  });

  watch(
    () => email.value.val,
    () => {
      if ((email.value.val?.length ?? 0) > 0) {
        email.value.enabled = true;
      }
    }
  );

  watch(
    () => password.value.val,
    () => {
      if ((password.value.val?.length ?? 0) > 0) {
        password.value.enabled = true;
      }
    }
  );

  function validate(field: GenericField): GenericField {
    return validator().validateField(field);
  }

  const successForm = computed(() => {
    email.value = validate(email.value);
    password.value = validate(password.value);
    return !(email.value.isSuccess && password.value.isSuccess);
  });

  function reset(): void {
    email.value.val = "";
    password.value.val = "";
    email.value.enabled = false;
    password.value.enabled = false;
  }

  return {
    email,
    password,
    successForm,
    reset,
  };
}
